<template>
    <div
        v-if="cardNumber > 0"
        class="foulCard"
        v-bind:class="{ _away: isAway }"
    >
        <div
            v-for="index in cardNumber"
            v-bind:key="index"
            class="foulCard-item"
        />
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'FoulCard',
        props: {
            isAway: { type: Boolean, default: false },
            cardNumber: { type: Number, default: 0 },
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/foulCard";
</style>
